// 导入axios
import axios from 'axios';

// 进行一些全局配置
// 公共路由(网络请求地址)
axios.defaults.baseURL = '/proxyserver';
// 请求响应超时时间
axios.defaults.timeout = 10000;
// 接口鉴权token
// const AuthToken = '63C5955F000AC45714978E04378638C8';

// 封装自己的get/post方法
export default {
  get: function(path = '', data = {}) {
    var user_token = localStorage.getItem("access_token") || "";
    return new Promise(function(resolve, reject) {
      axios.get(path, {
        params: data,
        headers: { 
          'authorization': 'Bearer ' + user_token
        }
      })
        .then(function(response) {
          // 按需求来，这里我需要的是response.data，所以返回response.data，一般直接返回response
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  post: function(path = '', data = {}) {
    return new Promise(function(resolve, reject) {
      var user_token = localStorage.getItem("access_token") || "";
      var headers = {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + user_token
      };
      axios.post(path, data, { headers: headers })
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
};
